import { Avatar, Box } from "@mui/material";
import { initials } from "../../../common/avatar";

// Theme palette roles, so community marks follow the Player theme.
const PALETTE = ["primary", "info", "success", "warning", "secondary", "error"] as const;

function paletteFor(id: string): (typeof PALETTE)[number] {
  let hash = 0;
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

/**
 * Initials avatar for a community, colored deterministically from its id.
 * `ring` marks new activity (unread chat) without any extra text.
 */
export function CommunityAvatar({
  communityId,
  name,
  size = 40,
  ring = false,
}: {
  communityId: string;
  name: string;
  size?: number;
  ring?: boolean;
}) {
  const role = paletteFor(communityId);
  return (
    <Box
      sx={{
        p: "2px",
        borderRadius: "50%",
        border: 2,
        borderColor: ring ? "primary.main" : "transparent",
        display: "inline-flex",
        flexShrink: 0,
      }}
    >
      <Avatar
        aria-hidden
        sx={{
          width: size,
          height: size,
          bgcolor: `${role}.main`,
          color: `${role}.contrastText`,
          fontWeight: 700,
          fontSize: size * 0.36,
        }}
      >
        {initials(name.replace(/[[\]()]/g, " "))}
      </Avatar>
    </Box>
  );
}
